import {connect} from 'react-redux';
import {AnyAction, Dispatch} from 'redux';
import * as ModalActions from '../../../../common/actions/ModalActions';
import {REOPEN_APPLICATION_ACTION} from '../actions/FinishActions';
import ReopenApplicationConfirmView, {ReopenApplicationConfirmProps} from '../components/views/ReopenApplicationConfirmView';

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): ReopenApplicationConfirmProps => ({
    onPressConfirm: () => dispatch(REOPEN_APPLICATION_ACTION.action()),
    onPressClose: () => dispatch(ModalActions.CLOSE_MODAL_ACTION.action()),
});

const ReopenApplicationConfirmContainer = connect(
    null, mapDispatchToProps
)(ReopenApplicationConfirmView);

export default ReopenApplicationConfirmContainer;
